import { Button } from '@/shared/ui/button.tsx';
import {
  Sheet,
  SheetContent,
  SheetFooter,
  SheetTrigger,
} from '@/shared/ui/sheet.tsx'
import { ListOrdered } from 'lucide-react';
import EventInfoContainer from './EventInfoContainer';

type Props = {
  eventsList: { name: string, id: number }[],
  selected: string,
  setSelected: (id: string) => void;
  date: {
    start_date: string,
    end_date: string,
  }
}

const EventInfoContainerSheet = ({eventsList, selected, date, setSelected}: Props) => {
  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button variant="outline" size="icon" className='flex lg:hidden'>
          <ListOrdered />
        </Button>
      </SheetTrigger>
      <SheetContent side="left" className='w-[70vw] md:w-[55vw]'>
        <EventInfoContainer 
          eventsList={eventsList} 
          setSelected={setSelected}
          date={date}
          selected={selected}
        />
        <SheetFooter>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  )
}

export default EventInfoContainerSheet
